export const UPDATE_CURRENT_FEATURE = "UPDATE_CURRENT_FEATURE";
export const SET_MAP_TOOLS = "SET_MAP_TOOLS";
export const PATH_UPDATE = "PATH_UPDATE";
export const PATHS_UPDATE = "PATHS_UPDATE";
export const PATH_DELETE = "PATH_DELETE";
export const ACTIVE_PATH_SET = "ACTIVE_PATH_SET";
// export const SPOTLIGHT_SET = "SPOTLIGHT_SET";
// export const SPOTLIGHT_REMOVE = "SPOTLIGHT_REMOVE";
// export const SPOTLIGHT_RESTART = "SPOTLIGHT_RESTART";
